import { Tabs, Tab } from "@mui/material";
import a11yProps from "helpers/ay-props";
import { CheckHasPermission } from "helpers/Common_functions";
import secureLocalStorage from "react-secure-storage";

const TabBoxComponent = (props) => {
  const { selectedValue, handleTabChange, tabList } = props;
const tabsList= tabList.filter((item)=>item?.permissionCode?CheckHasPermission(item?.permissionCode, "read"):true)

const settings = secureLocalStorage.getItem("systemSettings");
const settingsInfo = JSON.parse(settings);
const mainBackground = settingsInfo?.mainBackground;

  return (
    <Tabs
      value={selectedValue}
      onChange={handleTabChange}
      aria-label="basic tabs example"
      TabIndicatorProps={{
        style: {
          borderRadius: "10px",
          backgroundColor: mainBackground,
        },
      }}
    >
      {tabsList?.map((item) =>
        <Tab
        label={item.label}
        key={item.tabValue}
        value={item.tabValue}
        style={{
          marginLeft: "10px",
          marginBottom: "10px",
          marginTop: "10px",
          borderRadius: "10px",
          backgroundColor:
            item?.tabValue === selectedValue ? mainBackground : "transparent",
          color: item?.tabValue === selectedValue ? "white" : "black",
        }}
        {...a11yProps(item?.tabValue)}
      />
      )}
    </Tabs>
  );
};

export default TabBoxComponent;
